module.exports = __webpack_public_path__ + "img/icon5.6a1eb322.png";